module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticStyle: {
      "min-height": "86vh"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "home"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/dashboard-bg.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": "",
      "md6": "",
      "pr-1": _vm.$vuetify.breakpoint.mdAndUp,
      "pb-1": _vm.$vuetify.breakpoint.smAndDown
    }
  }, [_c('v-card', {
    staticClass: "fill-height"
  }, [_c('v-radio-group', {
    staticClass: "px-4 pt-4",
    attrs: {
      "mandatory": false,
      "row": ""
    },
    model: {
      value: (_vm.radios),
      callback: function($$v) {
        _vm.radios = $$v
      },
      expression: "radios"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "Unread",
      "value": "unread"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "Read",
      "value": "read"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.announcements,
      "loading": _vm.loading,
      "pagination": _vm.pagination,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          style: (("cursor: pointer; " + (_vm.subjectData.id === props.item.id ? 'background-color: #E0E0E0' : ''))),
          on: {
            "click": function($event) {
              return _vm.showDetails(props.item)
            }
          }
        }, [_c('td', {
          style: (_vm.subjectData.id === props.item.id ? 'font-weight: 900 !important' : '')
        }, [_vm._v(_vm._s(props.item.subject))]), _vm._v(" "), _c('td', {
          style: (_vm.subjectData.id === props.item.id ? 'font-weight: 900 !important' : '')
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "180px"
          }
        }, [_c('v-btn', {
          staticClass: "primary elevation-1 mx-0",
          on: {
            "click": function($event) {
              return _vm.showDetails(props.item)
            }
          }
        }, [_vm._v("\n              show\n            ")])], 1)])]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  })], 1)], 1)], 1), _vm._v(" "), (_vm.announcements && _vm.announcements.length > 0) ? _c('v-flex', {
    attrs: {
      "sm12": "",
      "md6": "",
      "pl-1": _vm.$vuetify.breakpoint.mdAndUp,
      "pt-1": _vm.$vuetify.breakpoint.smAndDown
    }
  }, [_c('v-card', {
    staticClass: "py-3 px-4 fill-height"
  }, [_c('v-layout', {
    staticStyle: {
      "border-bottom": "1px solid #E0E0E0"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.subjectData.subject || ''))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "pr-2"
  }, [_c('small', [_vm._v(_vm._s(_vm.formatDate(_vm.subjectData.createdOn)))])]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 mx-0",
    attrs: {
      "disabled": _vm.subjectData.isRead,
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.markAsRead()
      }
    }
  }, [_vm._v("\n            Mark as read\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pt-4",
    domProps: {
      "innerHTML": _vm._s(_vm.subjectData.message)
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13da116e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 388
// module chunks = 35